import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CardInfoContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getInformativo(id: string): Observable<any> {
    return this.getInformativoContents(id).pipe(
      map(res => this.buildResponseCardInfoObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryInformativoContents[0].flatData;
  }

  private getInformativoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryInformativoContents(filter: "id eq '${id}'") {
          flatData {
            nome
            textoDestaque
            informacaoPrincipal
            descricao
            botoes {
              titulo
              uRL
              cor
              modal {
                id
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseCardInfoObject(card: any) {
    let buttons = [];
    if (card.botoes) {
      buttons = card.botoes.map(button => {
        return {
          color: button.cor,
          title: button.titulo,
          url: button.uRL,
          modal: button.modal.length > 0 ? button.modal[0].id : null
        };
      });
    }

    return {
      buttons,
      description: card.descricao ? card.descricao : null,
      highlightText: card.textoDestaque ? card.textoDestaque : null,
      mainInfo: card.informacaoPrincipal ? card.informacaoPrincipal : null
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
